// extracted by css-extract-rspack-plugin
export default {"SidebarContentTitle":"lPDi6","backButton":"Q8h1c"};